import { getWebInstrumentations } from '@grafana/faro-react'
import { faro } from '@grafana/faro-web-sdk'
import { v4 as uuidv4 } from 'uuid'

import bandwidthUtils from 'utils/grafana/bandwidthUtils'

const isGrafanaFaroEnabled = window.checkFeatureFlag('ff-grafana-faro')

const grafanaUtils = {
  getInitialOptions() {
    const isPerformanceInstrumentationEnabled = window.checkFeatureFlag(
      'ff-performance-instrumentation'
    )
    const initialOptions = {
      apiKey: process.env.REACT_APP_API_KEY_GRAFANA_FARO,
      app: {
        environment: window.viewer.grafanaFaroEnvironment,
        name: 'edubook_viewer',
      },
      batching: {
        enabled: true,
      },
      instrumentations: [
        ...getWebInstrumentations({
          captureConsole: true,
          enablePerformanceInstrumentation: isPerformanceInstrumentationEnabled,
        }),
      ],
      session: window.__PRELOADED_STATE__?.faro?.session,
      url: window.viewer.grafanaFaroUrl,
    }
    return initialOptions
  },
  getUuidDevice() {
    let uuid = localStorage.getItem('uuidDevice')
    if (!uuid) {
      uuid = uuidv4()
      localStorage.setItem('uuidDevice', uuid)
    }
    return uuid
  },
  pushError(error, attributes) {
    if (!isGrafanaFaroEnabled) {
      return
    }
    faro.api.pushError(error, attributes)
  },
  pushEvent(name, attributes) {
    if (!isGrafanaFaroEnabled) {
      return
    }
    faro.api.pushEvent(name, attributes)
  },
  pushMeasurement(type, values) {
    if (!isGrafanaFaroEnabled) {
      return
    }
    faro.api.pushMeasurement({
      type: type,
      values: values,
    })
  },
  async setGrafanaUser(book) {
    if (!isGrafanaFaroEnabled) {
      return
    }

    try {
      const {
        book: { bookId, type },
        user: { id: userId, role },
        userBook: { classroom, id: userBookId },
      } = book

      const bandWidthSpeed = await bandwidthUtils.getBandwidthSpeed()
      const uuidDevice = grafanaUtils.getUuidDevice()

      const attributes = {
        bandWidthSpeed: bandWidthSpeed,
        bookId: bookId ? bookId.toString() : null,
        bookType: type,
        navigation: book.book?.navigationType,
        role: role,
        schoolId: classroom?.school?.id || null,
        userBookId: userBookId,
        uuidDevice: uuidDevice,
      }

      faro.api.setUser({
        attributes: attributes,
        id: userId,
      })
    } catch (error) {
      console.error('setGrafanaUser', error)
    }
  },
  setGrafanaUuidDevice() {
    if (!isGrafanaFaroEnabled) {
      return
    }
    const uuidDevice = grafanaUtils.getUuidDevice()

    faro.api.setUser({
      attributes: {
        uuidDevice: uuidDevice,
      },
    })
  },
  setView(view) {
    if (!isGrafanaFaroEnabled) {
      return
    }
    faro.api.setView({ name: view })
  },
}

export default grafanaUtils
